import { render, staticRenderFns } from "./Export_PenilikanLubangTanamPetani.vue?vue&type=template&id=5b4526ce"
import script from "./Export_PenilikanLubangTanamPetani.vue?vue&type=script&lang=js"
export * from "./Export_PenilikanLubangTanamPetani.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports